import authInstance, { nonAuthInstance } from "config/axios.config";

export const cmsServices = {
  getCmsPages: async ({
    page,
    limit,
    status,
    pageType,
    search,
    sortBy,
    sortOrder,
  }) => {
    const params = new URLSearchParams({
      page: page?.toString() || "1",
      limit: limit?.toString() || "10",
      status: status || "",
      pageType: pageType || "",
      search: search || "",
      sortBy: sortBy || "createdAt",
      sortOrder: sortOrder || "desc",
    });

    for (const [key, value] of [...params.entries()]) {
      if (!value || value.toLowerCase() === "all") {
        params.delete(key);
      }
    }

    const res = await authInstance.get(`/admin/cms?${params}`);
    return res.data;
  },

  getCmsPageById: async (cmsId) => {
    const res = await authInstance.get(`/admin/cms/${cmsId}`);
    return res.data;
  },

  addCmsPage: async (cmsData) => {
    const res = await authInstance.post("/admin/cms", cmsData);
    return res.data;
  },

  updateCmsPage: async ({ cmsId, cmsData }) => {
    const res = await authInstance.patch(`/admin/cms/${cmsId}`, cmsData);
    return res.data;
  },

  deleteCmsPage: async (cmsId) => {
    const res = await authInstance.delete(`/admin/cms/${cmsId}`);
    return res.data;
  },

  // Public API - Get CMS page by ID or slug (no authentication required)
  getPublicCmsPage: async (idOrSlug) => {
    const res = await nonAuthInstance.get(`/admin/cms/${idOrSlug}`);
    return res.data;
  },
};
